import { useContext, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import CookieConsent from "./components/cookie/CookieConsent";
import LoginRegistrate from "./pages/loginRegistrate/LoginRegistrate";
import Home from "./pages/home/Home";
import Apply from "./pages/apply/Apply";
import MyApplications from "./pages/myApplications/MyApplications";
import Profile from "./pages/profile/Profile";
import Header from "./components/header/Header";
import Loader from "./components/loader/Loader";
import Footer from "./components/footer/Footer";

const App = () => {
  const [userInfo, setUserInfo, loading] = useContext(UserContext); // Добавляем loading
  const [cookiesAllowed, setCookiesAllowed] = useState(false);
  const location = useLocation();

  // Проверка токена
  const checkToken = (userInfo) => {
    if (!userInfo) return false; // Добавлена проверка cookiesAllowed
    const token = userInfo.token;
    return token && token !== "";
  };

  const isAuthenticated = checkToken(userInfo);

  // Если идет загрузка, показываем индикатор
  if (loading) {
    return <Loader />;
  }

  // Если пользователь не авторизован и пытается получить доступ к защищенному маршруту
  // Исключаем маршрут политики cookies из проверки авторизации
  if (!isAuthenticated && location.pathname !== "/login") {
    return <Navigate to="/login" replace />;
  }

  // Если пользователь авторизован и пытается получить доступ к странице входа
  if (isAuthenticated && location.pathname === "/login") {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <CookieConsent onAccept={() => setCookiesAllowed(true)} />
      {isAuthenticated && <Header />}
      <div className={"pageWrapper"}>
        <div className={"mainContent"}>
          <Routes>
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/" replace /> : <LoginRegistrate />}
            />
            <Route path="/" element={isAuthenticated ? <Home isToken={isAuthenticated} /> : <Navigate to="/login" replace />} />
            <Route
              path="/my-applications"
              element={isAuthenticated ? <MyApplications isToken={isAuthenticated} /> : <Navigate to="/login" replace />}
            />
            <Route
              path="/apply/:id"
              element={isAuthenticated ? <Apply isToken={isAuthenticated} /> : <Navigate to="/login" replace />}
            />
            <Route
              path="/edit-profile"
              element={isAuthenticated ? <Profile isToken={isAuthenticated} /> : <Navigate to="/login" replace />}
            />
            <Route
              path="*"
              element={isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default App;